import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { httpconfigInterceptor } from './interceptors/httpconfig.interceptor';
import { ContentService } from './services/content.service';
import { tap } from 'rxjs/operators';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(withFetch(), withInterceptors([httpconfigInterceptor])),
    provideToastr(),
    provideAppInitializer(() => {
      const contentService = inject(ContentService);
      return new Promise((resolve) => {
        contentService.getInfoInit({ company: 20 }).pipe(
          tap((info: any) => {
            contentService.initInfo = info;
            resolve(true);
          })
        ).subscribe();
      });
    })
  ]
};
